import { BoxAttachmentsProps } from './types';
import { Icon } from '../UI';
import { Loading } from '../UI';
import { t } from 'i18next';

const BoxAttachments = (props: BoxAttachmentsProps) => {
  let { attachments, inputProps, rootProps, removeAttachment, loading } = props;

  return (
    <>
      {!attachments.length ? (
        <>
          <input {...inputProps()} />
          <div {...rootProps({ className: 'attach-box text-left' })}>
            <div className={'cursor-pointer text-grey-50'}>
              {loading ? (
                <Loading status={true} size={'small'} />
              ) : (
                <>
                  <Icon svgName={'anchor'} className={'inline-block mr-1'} />
                  {t('boxAttachments.attachImage')}
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          {attachments.map((attachment, index) => (
            <div
              className={
                'image-box inline-flex align-top w-16 h-16 mr-2 rounded-lg bg-grey-10 relative'
              }
              key={attachment.id}
            >
              <div
                className={
                  'bg-grey-30 absolute -right-2 -top-2 w-5 h-5 p-1.5 flex justify-center items-center rounded-full cursor-pointer'
                }
                onClick={(event) => removeAttachment(event, index)}
              >
                <Icon svgName={'close'} />
              </div>
              <div className={'w-full h-full rounded-lg overflow-hidden'}>
                <img
                  src={attachment.preview}
                  className={'object-cover h-full'}
                  alt={'attachment-' + index}
                />
              </div>
            </div>
          ))}

          <input {...inputProps()} />
          <div
            {...rootProps({
              className:
                'flex text-center justify-center items-center image-box inline-flex align-top w-16 h-16 mr-2 rounded-lg overflow-hidden cursor-pointer bg-grey-10',
            })}
          >
            {loading ? (
              <Loading status={true} size={'small'} />
            ) : (
              <Icon svgName={'plus'} />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default BoxAttachments;
